module.exports = __webpack_public_path__ + "static/media/zu2.589b6a53.png";